import LocaleUtilities from 'helpers/LocaleUtilities';
import etCountries from 'seed/et_countries.json';

export class CountryOption {
  label: string = '';
  value: string = '';
  isActive: boolean = true;
}

const getCountries = (): Array<CountryOption> => {
  const locale = LocaleUtilities.getCurrentLanguage();
  if (locale === 'Estonian') {
    return etCountries.map((item) => {
      return { label: item.value, value: item.code, isActive: true };
    });
  }
  return countries_en;
};

const countries_en: Array<CountryOption> = [
  { label: 'Afghanistan', value: 'AF', isActive: true },
  { label: 'Åland Islands', value: 'AX', isActive: true },
  { label: 'Albania', value: 'AL', isActive: true },
  { label: 'Algeria', value: 'DZ', isActive: true },
  { label: 'American Samoa', value: 'AS', isActive: true },
  { label: 'AndorrA', value: 'AD', isActive: true },
  { label: 'Angola', value: 'AO', isActive: true },
  { label: 'Anguilla', value: 'AI', isActive: true },
  { label: 'Antarctica', value: 'AQ', isActive: true },
  { label: 'Antigua and Barbuda', value: 'AG', isActive: true },
  { label: 'Argentina', value: 'AR', isActive: true },
  { label: 'Armenia', value: 'AM', isActive: true },
  { label: 'Aruba', value: 'AW', isActive: true },
  { label: 'Australia', value: 'AU', isActive: true },
  { label: 'Austria', value: 'AT', isActive: true },
  { label: 'Azerbaijan', value: 'AZ', isActive: true },
  { label: 'Bahamas', value: 'BS', isActive: true },
  { label: 'Bahrain', value: 'BH', isActive: true },
  { label: 'Bangladesh', value: 'BD', isActive: true },
  { label: 'Barbados', value: 'BB', isActive: true },
  { label: 'Belarus', value: 'BY', isActive: true },
  { label: 'Belgium', value: 'BE', isActive: true },
  { label: 'Belize', value: 'BZ', isActive: true },
  { label: 'Benin', value: 'BJ', isActive: true },
  { label: 'Bermuda', value: 'BM', isActive: true },
  { label: 'Bhutan', value: 'BT', isActive: true },
  { label: 'Bolivia', value: 'BO', isActive: true },
  { label: 'Bosnia and Herzegovina', value: 'BA', isActive: true },
  { label: 'Botswana', value: 'BW', isActive: true },
  { label: 'Bouvet Island', value: 'BV', isActive: true },
  { label: 'Brazil', value: 'BR', isActive: true },
  { label: 'British Indian Ocean Territory', value: 'IO', isActive: true },
  { label: 'Brunei Darussalam', value: 'BN', isActive: true },
  { label: 'Bulgaria', value: 'BG', isActive: true },
  { label: 'Burkina Faso', value: 'BF', isActive: true },
  { label: 'Burundi', value: 'BI', isActive: true },
  { label: 'Cambodia', value: 'KH', isActive: true },
  { label: 'Cameroon', value: 'CM', isActive: true },
  { label: 'Canada', value: 'CA', isActive: true },
  { label: 'Cape Verde', value: 'CV', isActive: true },
  { label: 'Cayman Islands', value: 'KY', isActive: true },
  { label: 'Central African Republic', value: 'CF', isActive: true },
  { label: 'Chad', value: 'TD', isActive: true },
  { label: 'Chile', value: 'CL', isActive: true },
  { label: 'China', value: 'CN', isActive: true },
  { label: 'Christmas Island', value: 'CX', isActive: true },
  { label: 'Cocos (Keeling) Islands', value: 'CC', isActive: true },
  { label: 'Colombia', value: 'CO', isActive: true },
  { label: 'Comoros', value: 'KM', isActive: true },
  { label: 'Congo', value: 'CG', isActive: true },
  { label: 'Congo, The Democratic Republic of the', value: 'CD', isActive: true },
  { label: 'Cook Islands', value: 'CK', isActive: true },
  { label: 'Costa Rica', value: 'CR', isActive: true },
  { label: "Cote D'Ivoire", value: 'CI', isActive: true },
  { label: 'Croatia', value: 'HR', isActive: true },
  { label: 'Cuba', value: 'CU', isActive: true },
  { label: 'Cyprus', value: 'CY', isActive: true },
  { label: 'Czech Republic', value: 'CZ', isActive: true },
  { label: 'Denmark', value: 'DK', isActive: true },
  { label: 'Djibouti', value: 'DJ', isActive: true },
  { label: 'Dominica', value: 'DM', isActive: true },
  { label: 'Dominican Republic', value: 'DO', isActive: true },
  { label: 'Ecuador', value: 'EC', isActive: true },
  { label: 'Egypt', value: 'EG', isActive: true },
  { label: 'El Salvador', value: 'SV', isActive: true },
  { label: 'Equatorial Guinea', value: 'GQ', isActive: true },
  { label: 'Eritrea', value: 'ER', isActive: true },
  { label: 'Estonia', value: 'EE', isActive: true },
  { label: 'Ethiopia', value: 'ET', isActive: true },
  { label: 'Falkland Islands (Malvinas)', value: 'FK', isActive: true },
  { label: 'Faroe Islands', value: 'FO', isActive: true },
  { label: 'Fiji', value: 'FJ', isActive: true },
  { label: 'Finland', value: 'FI', isActive: true },
  { label: 'France', value: 'FR', isActive: true },
  { label: 'French Guiana', value: 'GF', isActive: true },
  { label: 'French Polynesia', value: 'PF', isActive: true },
  { label: 'French Southern Territories', value: 'TF', isActive: true },
  { label: 'Gabon', value: 'GA', isActive: true },
  { label: 'Gambia', value: 'GM', isActive: true },
  { label: 'Georgia', value: 'GE', isActive: true },
  { label: 'Germany', value: 'DE', isActive: true },
  { label: 'Ghana', value: 'GH', isActive: true },
  { label: 'Gibraltar', value: 'GI', isActive: true },
  { label: 'Greece', value: 'GR', isActive: true },
  { label: 'Greenland', value: 'GL', isActive: true },
  { label: 'Grenada', value: 'GD', isActive: true },
  { label: 'Guadeloupe', value: 'GP', isActive: true },
  { label: 'Guam', value: 'GU', isActive: true },
  { label: 'Guatemala', value: 'GT', isActive: true },
  { label: 'Guernsey', value: 'GG', isActive: true },
  { label: 'Guinea', value: 'GN', isActive: true },
  { label: 'Guinea-Bissau', value: 'GW', isActive: true },
  { label: 'Guyana', value: 'GY', isActive: true },
  { label: 'Haiti', value: 'HT', isActive: true },
  { label: 'Heard Island and Mcdonald Islands', value: 'HM', isActive: true },
  { label: 'Holy See (Vatican City State)', value: 'VA', isActive: true },
  { label: 'Honduras', value: 'HN', isActive: true },
  { label: 'Hong Kong', value: 'HK', isActive: true },
  { label: 'Hungary', value: 'HU', isActive: true },
  { label: 'Iceland', value: 'IS', isActive: true },
  { label: 'India', value: 'IN', isActive: true },
  { label: 'Indonesia', value: 'ID', isActive: true },
  { label: 'Iran, Islamic Republic Of', value: 'IR', isActive: true },
  { label: 'Iraq', value: 'IQ', isActive: true },
  { label: 'Ireland', value: 'IE', isActive: true },
  { label: 'Isle of Man', value: 'IM', isActive: true },
  { label: 'Israel', value: 'IL', isActive: true },
  { label: 'Italy', value: 'IT', isActive: true },
  { label: 'Jamaica', value: 'JM', isActive: true },
  { label: 'Japan', value: 'JP', isActive: true },
  { label: 'Jersey', value: 'JE', isActive: true },
  { label: 'Jordan', value: 'JO', isActive: true },
  { label: 'Kazakhstan', value: 'KZ', isActive: true },
  { label: 'Kenya', value: 'KE', isActive: true },
  { label: 'Kiribati', value: 'KI', isActive: true },
  { label: "Korea, Democratic People'S Republic of", value: 'KP', isActive: true },
  { label: 'Korea, Republic of', value: 'KR', isActive: true },
  { label: 'Kosovo', value: 'XK', isActive: true },
  { label: 'Kuwait', value: 'KW', isActive: true },
  { label: 'Kyrgyzstan', value: 'KG', isActive: true },
  { label: "Lao People'S Democratic Republic", value: 'LA', isActive: true },
  { label: 'Latvia', value: 'LV', isActive: true },
  { label: 'Lebanon', value: 'LB', isActive: true },
  { label: 'Lesotho', value: 'LS', isActive: true },
  { label: 'Liberia', value: 'LR', isActive: true },
  { label: 'Libyan Arab Jamahiriya', value: 'LY', isActive: true },
  { label: 'Liechtenstein', value: 'LI', isActive: true },
  { label: 'Lithuania', value: 'LT', isActive: true },
  { label: 'Luxembourg', value: 'LU', isActive: true },
  { label: 'Macao', value: 'MO', isActive: true },
  { label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK', isActive: true },
  { label: 'Madagascar', value: 'MG', isActive: true },
  { label: 'Malawi', value: 'MW', isActive: true },
  { label: 'Malaysia', value: 'MY', isActive: true },
  { label: 'Maldives', value: 'MV', isActive: true },
  { label: 'Mali', value: 'ML', isActive: true },
  { label: 'Malta', value: 'MT', isActive: true },
  { label: 'Marshall Islands', value: 'MH', isActive: true },
  { label: 'Martinique', value: 'MQ', isActive: true },
  { label: 'Mauritania', value: 'MR', isActive: true },
  { label: 'Mauritius', value: 'MU', isActive: true },
  { label: 'Mayotte', value: 'YT', isActive: true },
  { label: 'Mexico', value: 'MX', isActive: true },
  { label: 'Micronesia, Federated States of', value: 'FM', isActive: true },
  { label: 'Moldova, Republic of', value: 'MD', isActive: true },
  { label: 'Monaco', value: 'MC', isActive: true },
  { label: 'Mongolia', value: 'MN', isActive: true },
  { label: 'Montserrat', value: 'MS', isActive: true },
  { label: 'Morocco', value: 'MA', isActive: true },
  { label: 'Mozambique', value: 'MZ', isActive: true },
  { label: 'Myanmar', value: 'MM', isActive: true },
  { label: 'Namibia', value: 'NA', isActive: true },
  { label: 'Nauru', value: 'NR', isActive: true },
  { label: 'Nepal', value: 'NP', isActive: true },
  { label: 'Netherlands', value: 'NL', isActive: true },
  { label: 'Netherlands Antilles', value: 'AN', isActive: true },
  { label: 'New Caledonia', value: 'NC', isActive: true },
  { label: 'New Zealand', value: 'NZ', isActive: true },
  { label: 'Nicaragua', value: 'NI', isActive: true },
  { label: 'Niger', value: 'NE', isActive: true },
  { label: 'Nigeria', value: 'NG', isActive: true },
  { label: 'Niue', value: 'NU', isActive: true },
  { label: 'Norfolk Island', value: 'NF', isActive: true },
  { label: 'Northern Mariana Islands', value: 'MP', isActive: true },
  { label: 'Norway', value: 'NO', isActive: true },
  { label: 'Oman', value: 'OM', isActive: true },
  { label: 'Pakistan', value: 'PK', isActive: true },
  { label: 'Palau', value: 'PW', isActive: true },
  { label: 'Palestinian Territory, Occupied', value: 'PS', isActive: true },
  { label: 'Panama', value: 'PA', isActive: true },
  { label: 'Papua New Guinea', value: 'PG', isActive: true },
  { label: 'Paraguay', value: 'PY', isActive: true },
  { label: 'Peru', value: 'PE', isActive: true },
  { label: 'Philippines', value: 'PH', isActive: true },
  { label: 'Pitcairn', value: 'PN', isActive: true },
  { label: 'Poland', value: 'PL', isActive: true },
  { label: 'Portugal', value: 'PT', isActive: true },
  { label: 'Puerto Rico', value: 'PR', isActive: true },
  { label: 'Qatar', value: 'QA', isActive: true },
  { label: 'Reunion', value: 'RE', isActive: true },
  { label: 'Romania', value: 'RO', isActive: true },
  { label: 'Russian Federation', value: 'RU', isActive: true },
  { label: 'RWANDA', value: 'RW', isActive: true },
  { label: 'Saint Helena', value: 'SH', isActive: true },
  { label: 'Saint Kitts and Nevis', value: 'KN', isActive: true },
  { label: 'Saint Lucia', value: 'LC', isActive: true },
  { label: 'Saint Pierre and Miquelon', value: 'PM', isActive: true },
  { label: 'Saint Vincent and the Grenadines', value: 'VC', isActive: true },
  { label: 'Samoa', value: 'WS', isActive: true },
  { label: 'San Marino', value: 'SM', isActive: true },
  { label: 'Sao Tome and Principe', value: 'ST', isActive: true },
  { label: 'Saudi Arabia', value: 'SA', isActive: true },
  { label: 'Senegal', value: 'SN', isActive: true },
  { label: 'Serbia and Montenegro', value: 'CS', isActive: true },
  { label: 'Seychelles', value: 'SC', isActive: true },
  { label: 'Sierra Leone', value: 'SL', isActive: true },
  { label: 'Singapore', value: 'SG', isActive: true },
  { label: 'Slovakia', value: 'SK', isActive: true },
  { label: 'Slovenia', value: 'SI', isActive: true },
  { label: 'Solomon Islands', value: 'SB', isActive: true },
  { label: 'Somalia', value: 'SO', isActive: true },
  { label: 'South Africa', value: 'ZA', isActive: true },
  { label: 'South Georgia and the South Sandwich Islands', value: 'GS', isActive: true },
  { label: 'Spain', value: 'ES', isActive: true },
  { label: 'Sri Lanka', value: 'LK', isActive: true },
  { label: 'Sudan', value: 'SD', isActive: true },
  { label: 'Suriname', value: 'SR', isActive: true },
  { label: 'Svalbard and Jan Mayen', value: 'SJ', isActive: true },
  { label: 'Swaziland', value: 'SZ', isActive: true },
  { label: 'Sweden', value: 'SE', isActive: true },
  { label: 'Switzerland', value: 'CH', isActive: true },
  { label: 'Syrian Arab Republic', value: 'SY', isActive: true },
  { label: 'Taiwan, Province of China', value: 'TW', isActive: true },
  { label: 'Tajikistan', value: 'TJ', isActive: true },
  { label: 'Tanzania, United Republic of', value: 'TZ', isActive: true },
  { label: 'Thailand', value: 'TH', isActive: true },
  { label: 'Timor-Leste', value: 'TL', isActive: true },
  { label: 'Togo', value: 'TG', isActive: true },
  { label: 'Tokelau', value: 'TK', isActive: true },
  { label: 'Tonga', value: 'TO', isActive: true },
  { label: 'Trinidad and Tobago', value: 'TT', isActive: true },
  { label: 'Tunisia', value: 'TN', isActive: true },
  { label: 'Turkey', value: 'TR', isActive: true },
  { label: 'Turkmenistan', value: 'TM', isActive: true },
  { label: 'Turks and Caicos Islands', value: 'TC', isActive: true },
  { label: 'Tuvalu', value: 'TV', isActive: true },
  { label: 'Uganda', value: 'UG', isActive: true },
  { label: 'Ukraine', value: 'UA', isActive: true },
  { label: 'United Arab Emirates', value: 'AE', isActive: true },
  { label: 'United Kingdom', value: 'GB', isActive: true },
  { label: 'United States', value: 'US', isActive: true },
  { label: 'United States Minor Outlying Islands', value: 'UM', isActive: true },
  { label: 'Uruguay', value: 'UY', isActive: true },
  { label: 'Uzbekistan', value: 'UZ', isActive: true },
  { label: 'Vanuatu', value: 'VU', isActive: true },
  { label: 'Venezuela', value: 'VE', isActive: true },
  { label: 'Viet Nam', value: 'VN', isActive: true },
  { label: 'Virgin Islands, British', value: 'VG', isActive: true },
  { label: 'Virgin Islands, U.S.', value: 'VI', isActive: true },
  { label: 'Wallis and Futuna', value: 'WF', isActive: true },
  { label: 'Western Sahara', value: 'EH', isActive: true },
  { label: 'Yemen', value: 'YE', isActive: true },
  { label: 'Zambia', value: 'ZM', isActive: true },
  { label: 'Zimbabwe', value: 'ZW', isActive: true },
];

export default getCountries;
